import React from "react";
import { Order, Product } from "../MyOrders/MyOrders";


interface OrderTableMobileProps {
  orders: Order[];
}

const OrderTableMobile: React.FC<OrderTableMobileProps> = ({ orders }) => {
  return (
    <div className="space-y-4 p-4 w-full  ]">
    
       {orders.length > 0 ? (
        orders.map((order) => (
          <div key={order.id} className="border border-[#75A7AD]
           rounded-lg p-6 shadow-md bg-white">
            <h2 className="text-lg font-bold text-[#080A40] mb-2">
              Order Reference: {order.reference_number}
            </h2>
            {Array.isArray(order.products) && order.products.length > 0 ? (
              order.products.map((product: Product) => (
                <div key={product.product_id} className="mb-4">
                  <h3 className="text-md font-semibold text-[#080A40]">{product.name}</h3>
                  <p className="text-sm text-gray-600">Quantity: {product.quantity}</p>
                  <p className="text-sm text-gray-600">
                    Total Price: <span className="font-bold">R{(product.price * product.quantity).toFixed(2)}</span>
                  </p>
                  <p className="text-sm text-gray-600">Status: {order.status}</p>
                  <p className="text-sm text-gray-600">Order Type: {product.order_type}</p>
                  <p className="text-sm text-gray-600">
                    Date Ordered: {order.requested_ship_date ? new Date(order.requested_ship_date).toLocaleDateString() : 'N/A'}
                  </p>
                </div>
              ))
            ) : (
              <p className="text-sm text-gray-500">No products found for this order</p>
            )}
          </div>
        ))
      ) : (
        <div className="text-center text-gray-500">No orders found</div>
      )}
    </div>
  );
};

export default OrderTableMobile;
